import { Button } from '@lokalise/louis'
import { IrregularButtonLayout } from '../../IrregularButtonLayout/IrregularButtonLayout'
import { DialVariant1, DialVariant2 } from '../../RadialDial/RadialDial'
import { INTERCOM_BUTTON_ID } from '../constants/intercom'
import { useDispatchBannerAnalyticsEvent } from '../hooks/useDispatchBannerAnalyticsEvent'
import {
  BannerContainer,
  BannerCTAContainer,
  BannerCTASubText,
  BannerHeader,
  BannerHideIfContainerTooSmall,
  BannerSubHeader,
  BannerSubHeaderBlue,
  BannerTextBody,
  BannerTextContainer,
} from './BannerComponents'

// Shown when user has no access to custom profiles
export const UpsellBannerVariant1 = () => {
  useDispatchBannerAnalyticsEvent('static_less_editing')

  return (
    <BannerContainer>
      <BannerTextContainer>
        <BannerSubHeader>2 MIN SETUP</BannerSubHeader>
        <BannerHeader>Try Custom Profiles and save hours of translation editing.</BannerHeader>
        <BannerTextBody>
          Custom AI Profiles can deliver up to 40% less editing effort and significantly more
          edit-free translations than the Base AI Profile. Set up in just 2 minutes and scale
          consistent, high-quality translations with ease.
        </BannerTextBody>
      </BannerTextContainer>
      <BannerHideIfContainerTooSmall>
        <DialVariant1 />
      </BannerHideIfContainerTooSmall>
      <BannerCTAContainer>
        <Button variant="primary" id={INTERCOM_BUTTON_ID}>
          Unlock it and start translating
        </Button>
        <BannerCTASubText>
          Translate and compare your Custom Profile with the Base AI Profile and Google Translate
        </BannerCTASubText>
      </BannerCTAContainer>
    </BannerContainer>
  )
}

export const UpsellBannerVariant2 = () => {
  useDispatchBannerAnalyticsEvent('static_zero_edits')

  return (
    <BannerContainer>
      <BannerTextContainer>
        <BannerSubHeader>2 MIN SETUP</BannerSubHeader>
        <BannerHeader>Get 2.5x more translations that require zero edits</BannerHeader>
        <BannerTextBody>
          Stop wasting time fixing AI translations. Custom AI profiles use your approved content to
          improve translation quality, so you get over twice as many translations that need no
          edits. Set up in just 2 minutes and scale reliable, high-quality translations with ease.
        </BannerTextBody>
      </BannerTextContainer>
      <BannerHideIfContainerTooSmall>
        <DialVariant2 />
      </BannerHideIfContainerTooSmall>
      <BannerCTAContainer>
        <Button variant="primary" id={INTERCOM_BUTTON_ID}>
          Unlock it and start translating
        </Button>
        <BannerCTASubText>
          Translate and compare your Custom Profile with the Base AI Profile and Google Translate
        </BannerCTASubText>
      </BannerCTAContainer>
    </BannerContainer>
  )
}

export const UpsellBannerVariant3 = () => {
  useDispatchBannerAnalyticsEvent('static_market_specific')

  return (
    <BannerContainer>
      <BannerTextContainer>
        <BannerSubHeaderBlue>MARKET SPECIFIC TRANSLATIONS</BannerSubHeaderBlue>
        <BannerHeader>Tailor your content for specific target group</BannerHeader>
        <BannerTextBody>
          Upgrade to create custom AI profiles for every content type. Build separate profiles for
          Marketing, Product, Legal, Support, and more—so AI uses the right examples for every
          translation. Set up in just 2 minutes and scale consistent, high-quality content with
          ease.
        </BannerTextBody>
      </BannerTextContainer>
      <IrregularButtonLayout>
        <Button variant="primary" id={INTERCOM_BUTTON_ID}>
          Unlock it and start translating
        </Button>
      </IrregularButtonLayout>
    </BannerContainer>
  )
}
